import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { sendRequest } from '../requests/useRequest';
import { validarSesion } from '../tokens/useToken';
import { usePaginationBackend } from '../pagination/usePaginationBackend';
import { useDebounce } from '../debounce/useDebounce';
import { ConfigServer } from "../../data/config";
import formatEmail from '../../utils/validations/formatEmail'


export const useDoctors = ({ activeTab }) => {

    const history = useHistory();

    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert();
    const [dataDoctor, setDataDoctor] = useState([]);
    console.log("🚀 ~ useDoctors ~ dataDoctor:", dataDoctor)

    const [doctorId, setDoctorId] = useState(0);

    const [specialties, setSpecialties] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");
    const debounceValue = useDebounce(searchQuery, 500);

    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [method, setMethod] = useState("");
    const [password_microsite1, setPasswordMicrosite] = useState("");
    const [listSellers, setListSellers] = useState([]);
    // console.log("🚀 ~ useDoctors ~ listSellers:", listSellers)
    const [modalEmail, setModalEmail] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalMicrosite, setModalMicrosite] = useState(false);


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValuesA] = useForm({
        id_specialty: 0,
        name: "",
        professional_license: "",
        phone: "",
        address: "",
        email: "",
        name_specialty: "",
        code: "",
        username: "",
        password_microsite: "",
        handleInputChange: "",
        isCommercialPartner: false,
        id_seller: 0,
        whatsapp_doctor: ""
    });

    const { id_specialty, name, professional_license, phone, address, email, name_specialty, isCommercialPartner, code, username, password_microsite, id_seller, whatsapp_doctor } = formValues;

    const [nameInputs, setNameInputs] = useState({
        name: "name",
        id_specialty: "id_specialty",
        professional_license: "professional_license",
        phone: "phone",
        address: "address",
        email: "email",
        code: "code",
        isCommercialPartner: "isCommercialPartner",
        username: "username",
        password_microsite: "password_microsite",
        id_seller: "id_seller",
        whatsapp_doctor:"whatsapp_doctor"
    });

    const [validaciones, setValidaciones] = useState({
        id_specialty: false,
        name: false,
        email_validate: false,
        whatsapp_doctor_validate: false   
    });


    const toggle = () => {
        setModal(prev => !prev);
    };

    const closeModalDoctor = () => {
        setModal(false);
    };

    // #region IMG MICROSITE
    const openDialogMicrosite = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModalMicrosite(true);
    };

    const closeDialog = () => {
        setModalMicrosite(false);
    };

    const handleCreateMicrosite = () => {
        setMethod("create");
        setModalTitle("Imagen para micrositio(Login)");
        openDialogMicrosite("Imagen para micrositio(Login)", "create");
    }

    //#endregion

    //#region pagination
    const handleSearch = (value) => {
        setSearchQuery(value);
    }

    const handleClearFilter = () => {
        setSearchQuery("");
    };

    useEffect(() => {
        searchAsync();
    }, [debounceValue])

    const { goNextPage, goPreviousPage, goToPage, searchAsync, totalRecords, actualPage, totalPages, prevPage, nextPage, resultCount, results } = usePaginationBackend(
        { method: 'GET' },
        "Doctors/List",
        history,
        searchQuery,
    );

    useEffect(() => {

        let listDoctor = [];

        results.forEach((data, key) => {

            let visibleTable = true;

            listDoctor.push({
                id_doctor: data?.id_doctor,
                name: data?.name,
                id_specialty: data?.id_specialty,
                address: data?.address,
                email: data?.email,
                isCommercialPartner: data?.isCommercialPartner,
                phone: data?.phone,
                professional_license: data?.professional_license,
                code: data?.code,
                name_specialty: data?.name_specialty,
                username: data?.username,
                password_microsite: data?.password_microsite,
                id_seller: data?.id_seller,
                whatsapp_doctor: data?.whatsapp_doctor,
                //...data,
                visibleTable: visibleTable
            });
        });
        console.log("🚀 ~ results.forEach ~ listDoctor:", listDoctor)
        setDataDoctor(listDoctor);

    }, [results]);


    //#endregion pagination


    //#region Crud Doctor

    const handleGetSpecialties = async () => {
        let listTmp = await handleRequest("GET", `Specialties/List`, 'Especialidades');
        // ////console.log(listTmp);

        if (listTmp !== null && listTmp.length > 0) {
            let listSpecial = [];

            if (listTmp.length >= 1) {
                listTmp.forEach(element => {
                    listSpecial.push({
                        id_specialty: element.id_specialty,
                        name: element.name
                    })
                });
            }
            setSpecialties(listSpecial)
        }
    }

    const uploadImage = async ({ files }) => {
        const formData = new FormData();
        formData.append("doctor_microsite", files[0]);

        let token = localStorage.getItem("token");

        const response = await fetch("/api/Doctors/SaveMicrositeImage", {
            method: "POST",
            body: formData,
            headers: {
                Authorization: "Bearer " + token

            }
        });

        if (response.ok) {
            createSweet("create", "success", "Imagen Guardada");
            closeDialog();
        } else {
            createSweet("error", "error", "Error al guardar imagen");
        }
    };

    const isDoctorDuplicated = (newDoctor) => {
        const duplicatedDoctor = dataDoctor.find(doctor => doctor.name.toLowerCase() === newDoctor.name.toLowerCase());
        return duplicatedDoctor !== undefined;
    }

    const handleCreate = () => {
        handleUpdateValues({
            id_specialty: 0,
            name: "",
            professional_license: "",
            phone: "",
            address: "",
            email: "",
            name_specialty: "",
            code: "",
            isCommercialPartner: false,
            username: "",
            password_microsite: "",
            id_seller: 0,
            whatsapp_doctor: ""

        });

        ////console.log(handleUpdateValues);
        setDoctorId(0);
        setMethod("create");
        toggle();
        handleGetSpecialties();
        getSellers();
    }

    const saveCreate = async (e) => {

        // console.log("pasassdjjndsjdsnk");

        e.preventDefault();

        if (validarForm()) {
            return;
        }

        // console.log("+++++++++");


        // if (isDoctorDuplicated(formValues)) {
        //     createSweet("warning", "warning", "Médico Duplicado", "Este médico ya existe en la lista.");
        //     return;
        // }

        setLoading(true);

        let newForm = {
            id_specialty: formValues.id_specialty === "new" ? null : formValues.id_specialty,
            name: formValues.name,
            professional_license: formValues.professional_license,
            phone: formValues.phone,
            address: formValues.address,
            email: formValues.email,
            name_specialty: formValues.name_specialty,
            code: formValues.code,
            isCommercialPartner: formValues.isCommercialPartner === true ? 1 : null,
            password_microsite: formValues.password_microsite,
            username: formValues.username,
            id_seller: formValues.id_seller === "new" ? null : formValues.id_seller,
            whatsapp_doctor: formValues.whatsapp_doctor
        };

        let listTmp = await handleRequest("POST", "Doctors", "Doctores", newForm);
        ////console.log('listTmp',listTmp)
        if (listTmp !== null) {
            setLoading(false);
            const nuevoDoctor = {
                ...newForm,
                id_doctor: listTmp.id_doctor ?? Date.now(),
                visibleTable: true
            };

            setDataDoctor(prev => [nuevoDoctor, ...prev]);
            closeModalDoctor();
            createSweet("create", "success", "Médico creado");
        } else {
            setLoading(false);
        }

    }

    const handleUpdate = (id_doctor) => {
        let doctor = dataDoctor.find(x => x.id_doctor === parseInt(id_doctor));
        handleUpdateValues({
            id_specialty: doctor.id_specialty,
            name: doctor.name,
            professional_license: doctor.professional_license,
            phone: doctor.phone,
            address: doctor.address,
            email: doctor.email,
            code: doctor.code,
            isCommercialPartner: doctor.isCommercialPartner,
            username: doctor.username,
            password_microsite: doctor.password_microsite,
            id_seller: doctor.id_seller,
            whatsapp_doctor: doctor.whatsapp_doctor

        });

        setDoctorId(id_doctor);
        setMethod("update");
        handleGetSpecialties();
        toggle();
        getSellers();

    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        console.log("pasasas");


        if (validarForm()) {
            return;
        }

        console.log("pasasas222");




        setLoading(true);

        let newForm = {
            id_doctor: doctorId,
            id_specialty: (formValues.id_specialty === "new" ? null : formValues.id_specialty),
            name: formValues.name,
            professional_license: formValues.professional_license,
            phone: formValues.phone,
            address: formValues.address,
            email: formValues.email,
            code: formValues.code,
            isCommercialPartner: formValues.isCommercialPartner === true ? 1 : null,
            username: formValues.username,
            password_microsite: formValues.password_microsite,
            id_seller: (formValues.id_seller === "new" ? null : formValues.id_seller),
            whatsapp_doctor: formValues.whatsapp_doctor



        };

        let listTmp = await handleRequest("PUT", "Doctors/Update", "Doctores", newForm);

        if (listTmp !== null) {

            let a = dataDoctor
            let find = a.find(x => x.id_doctor === doctorId);

            let isCommercialPartner = formValues.isCommercialPartner === true ? 1 : null
            let name = formValues.name
            let id_specialty = (formValues.id_specialty === "new" ? null : formValues.id_specialty)
            let id_seller = (formValues.id_seller === "new" ? null : formValues.id_seller)

            if (find) {

                find.isCommercialPartner = isCommercialPartner
                find.name = name
                find.id_specialty = id_specialty
                find.id_seller = id_seller

                setDataDoctor(
                    a,
                    find
                );
            }

            handleUpdateValues({
                id_specialty: 0,
                name: "",
                professional_license: "",
                phone: "",
                address: "",
                email: "",
                name_specialty: "",
                code: "",
                isCommercialPartner: false,
                username: "",
                password_microsite: "",
                id_seller: 0,
                whatsapp_doctor: ""
            });

            setLoading(false);
            createSweet("create", "success", "Doctor actualizado correctamente");
            await searchAsync()
            setDoctorId(0);
            handleGetSpecialties();
            getSellers();
            closeModalDoctor();
        }
    }

    //delete Doctor
    const handleDelete = (id_doctor) => {
        let doctor = dataDoctor.find(x => x.id_doctor === parseInt(id_doctor));

        handleUpdateValues({
            name: doctor.name,
        });

        setDoctorId(id_doctor);
        setMethod("delete");
        toggle();
    }


    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let listTmp = await handleRequest("DELETE", `Doctors/${doctorId}`, "Doctores");

        if (listTmp !== null) {
            const updatedDoctors = dataDoctor.filter(doctor => doctor.id_doctor !== parseInt(doctorId));
            setDataDoctor(updatedDoctors);

            setLoading(false);
            setSearchQuery("");
            createSweet("create", "success", "Médico eliminado");

            closeModalDoctor();
        }
        else {
            setLoading(false);
            createSweet("create", "error", "Error al eliminar el médico");
        }
    }
    //beta-pedropp-configCompany

    //#endregion Crud Doctor

    //#region Validar Form

    const validarForm = () => {





        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.id_specialty <= 0) {
            newValidaciones = {
                ...newValidaciones,
                id_specialty: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                id_specialty: false
            }
        }

        if (formValues.name.length <= 2) {
            newValidaciones = {
                ...newValidaciones,
                name: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                name: false
            }
        }

        if (formValues.whatsapp_doctor && formValues.whatsapp_doctor.trim() !== "") {

        const numbers = formValues.whatsapp_doctor
            .split(",")
            .map(n => n.trim())
            .filter(n => n !== "");

        const invalid = numbers.some(n => !/^\d{10}$/.test(n));

        newValidaciones = {
            ...newValidaciones,
            whatsapp_doctor_validate: invalid
        };

        if (invalid) {
            statusValidacion = true;
        }
    }

        if (formValues.email && formValues.email !== "") {

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            let emails = formValues.email.split(',');
            let hasInvalidEmail = false;

            for (let email of emails) {
                email = email.trim();
                if (!emailRegex.test(email)) {
                    hasInvalidEmail = true;
                    createSweet("error", "warning", "Advertencia", `El correo '${email}' no cuenta con una estructura válida.`);
                }
            }

            newValidaciones = {
                ...newValidaciones,
                email_validate: hasInvalidEmail
            };

            if (hasInvalidEmail) {
                statusValidacion = true;
            }
        } else {
            newValidaciones = {
                ...newValidaciones,
                email_validate: false
            };
            statusValidacion = false;
        }




        setValidaciones({
            ...validaciones,
            ...newValidaciones
        });

        console.log("🚀 ~ validarForm ~ statusValidacion:", statusValidacion)
        return statusValidacion;
    }

    //#endregion Validar Form


    //GLOBAL REQUEST

    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 409) { // Añadiendo el manejo de error 409
            createSweet("warning", "warning", nameMethod, "Este médico ya existe.");
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    //#region Generate Password


    const generateRandomPassword = async () => {
        if (password_microsite && password_microsite.trim() !== "" && (!username || username.trim() === "")) {
            createSweet("error", "error", "Usuario requerido", "Debes ingresar un nombre de usuario antes de reemplazar la contraseña.");
            return;
        }

        let confirmed = false;

        if (password_microsite && password_microsite.trim() !== "") {
            confirmed = await sweetAcceptGlobal(
                "¿Deseas reemplazar la contraseña actual?",
                "Ya existe una contraseña. Esta acción la reemplazará con una nueva generada automáticamente. ¿Estás seguro de continuar?",
                "warning",
                true
            );
        } else {
            confirmed = await sweetAcceptGlobal(
                "¿Deseas generar una contraseña?",
                "Se generará una nueva contraseña automáticamente para este médico.",
                "question",
                true
            );
        }

        if (!confirmed) return;

        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let password = "";
        for (let i = 0; i < 8; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        handleInputChange({ target: { name: 'password_microsite', value: password } });

        createSweet("create", "success", "Contraseña generada", "Se ha generado una nueva contraseña correctamente.");
    };

    const downloadExcel = async () => {

        let token = localStorage.getItem("token");
        await fetch(ConfigServer.serverUrl + `/api/Doctors/DownloadDoctorsToExcel`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se descargo el archivo excel");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Lista de Doctores.xlsx");

                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }





    //endregion


    const getSellers = async () => {
        const response = await sendRequest("GET", "Seller/List", "Vendedores");

        if (response && response.data && response.data.length > 0) {
            const _list_seller = response.data.map(_seller => ({
                value: _seller.id_seller,
                label: _seller.name,
            }));

            setListSellers(_list_seller);
        } else {
            setListSellers([]);
        }

    };
    useEffect(() => {
        getSellers();
    }, []);


    // const handleSendEmail = (id_doctor) => {

    //     setDoctorId(id_doctor);
    //     toggleEmail()
    // }

    const handleSendEmail = (id_doctor) => {
        const doctor = dataDoctor.find(d => d.id_doctor === id_doctor);

        if (doctor) {
            handleUpdateValues({
                ...formValues,
                email: doctor.email ?? ""
            });
        }

        setDoctorId(id_doctor);
        setModalEmail(true);
    };

    const toggleEmail = () => {
        setModalEmail(false);
    }

    const saveEmailDoctor = async () => {

        if (!validarFormEmail()) return;


        setLoading(true);
        createSweet("create", "success", "", "Enviando......");

        let _form = {
            "id_doctor": doctorId,
            "emails": formValues.email
        }

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(_form)
        };

        const respuesta = await sendRequest(requestOptions, "Doctors/SendEmailDoctorsAccess");

        if (respuesta.code === 200) {
            setLoading(false);
            toggleEmail();
            setDoctorId(0);
            createSweet("create", "success", "Exito!", "Se ha enviado correctamente");
            handleUpdateValues({
                ...formValues,
                email: ""
            })
        }
        else {
            createSweet("warning", "warning", "Envios!", "No se pudo enviar el correo");
            setLoading(false);
            toggleEmail();
            setDoctorId(0);
            handleUpdateValues({
                ...formValues,
                email: ""
            })
        }
    }


    const [validacionesEmail, setValidacionesEmail] = useState({
        email_valid: false,

    });

    const validarFormEmail = () => {
        let newValidaciones = {
            email_valid: false
        };

        if (!formValues.email || formValues.email.trim() === "") {
            newValidaciones.email_valid = true;
            setValidacionesEmail(newValidaciones);

            return false;
        }

        setValidacionesEmail(newValidaciones);
        return true;
    };


    const MAX_SIZE = 2000000;
    const validateAndUpload = (event) => {
        
        const file = event.files[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            createSweet("info", "info", "No válido", "Solo imágenes.");
            return;
        }

        if (file.size > MAX_SIZE) {
            createSweet("info", "info", "Error en la imagen", "La imagen no debe superar 2MB.");
            return;
        }

        uploadImage(event);
    };

     const handleWhatsappDoctorChange = (e) => {
        const value = e.target.value;

        if (!/^[0-9,\s]*$/.test(value)) return;

        handleInputChange(e);
    };

    const validateWhatsappDoctor = () => {

        const value = formValues.whatsapp_doctor || "";

        if (value.trim() === "") {
            setValidaciones(prev => ({
                ...prev,
                whatsapp_doctor_validate: false
            }));
            return false;
        }

        const numbers = value
            .split(",")
            .map(n => n.trim())
            .filter(n => n !== "");

        const invalid = numbers.some(n => !/^\d{10}$/.test(n));

        setValidaciones(prev => ({
            ...prev,
            whatsapp_doctor_validate: invalid
        }));

        return invalid;
    };



    return {
        id_specialty, name, professional_license, phone, address, email, handleInputChange, specialties, code, username, password_microsite, id_seller,
        //pagination
        goNextPage, goPreviousPage, goToPage, actualPage, totalPages, prevPage, nextPage, dataDoctor, handleSearch, totalRecords,
        //method
        saveCreate, handleCreate, handleGetSpecialties, toggle, loading, method, modal, nameInputs, name_specialty,
        handleUpdate, saveUpdate, handleDelete, saveDelete, validaciones, isCommercialPartner, generateRandomPassword,

        //Excel
        downloadExcel, listSellers, handleSelectValuesA, handleSendEmail, toggleEmail, modalEmail, saveEmailDoctor, validacionesEmail, doctorId,

        closeModalDoctor, searchQuery, handleClearFilter,

        handleCreateMicrosite, closeDialog, uploadImage, modalMicrosite, validateAndUpload, MAX_SIZE, whatsapp_doctor, validateWhatsappDoctor, handleWhatsappDoctorChange

    }
}
